export default __webpack_public_path__ + "static/Marketable-c3e7482724fc46f94909b7f9881cee92.png";